import { Icon } from '../../../layout/Icon.jsx';
import { formatIQD, formatDateTime } from '../../../shared/format.js';
import { PrintLogo } from '../../../shared/PrintLogo.jsx';
import { Modal } from './Modal.jsx';
import './print.css';

const METHOD_LABELS = {
  cash: 'نقداً', transfer: 'تحويل', cheque: 'صك', card: 'بطاقة', other: 'أخرى'
};

/**
 * سند الصرف القابل للطباعة.
 * يُطبع عبر نفس أسلوب التقارير: `.print-root` وحده يظهر على الورق.
 */
export function VoucherPrint({ voucher, onClose }) {
  if (!voucher) return null;
  const p = voucher.payment || voucher;
  const isRefund = p.direction === 'in';
  const allocations = p.allocations || [];

  return (
    <Modal
      title={isRefund ? 'سند قبض — استرداد من المورد' : 'سند صرف'}
      sub={p.voucherNumber}
      width={720}
      onClose={onClose}
      footer={(
        <>
          <button type="button" className="btn flex-1 justify-center" onClick={onClose}>إغلاق</button>
          <button type="button" className="btn btn-primary flex-1 justify-center" onClick={() => window.print()}>
            <Icon name="print" size={14} /> طباعة السند
          </button>
        </>
      )}
    >
      <div className="print-root">
        {/* شعار المركز من الإعدادات — أعلى الورقة ووسطها */}
        <PrintLogo />
        <div className="print-section text-center mb-3">
          <h2 className="text-[18px] font-extrabold m-0">
            {isRefund ? 'سند قبض (استرداد من مورد)' : 'سند صرف'}
          </h2>
          <div className="text-[13px] text-ink-2 mt-1">
            رقم السند: <b style={{ fontFamily: 'monospace' }}>{p.voucherNumber}</b>
          </div>
          {p.status === 'reversed' ? (
            <div className="text-[13px] font-bold mt-1" style={{ color: '#B91C1C' }}>
              ⚠️ سند معكوس بقيد موثّق — {p.reverseReason || ''}
            </div>
          ) : null}
        </div>

        <table className="print-section">
          <tbody>
            <tr>
              <th style={{ width: '22%' }}>اسم المورد</th>
              <td>{p.supplierName || '—'}</td>
              <th style={{ width: '22%' }}>هاتف المورد</th>
              <td style={{ fontFamily: 'monospace' }}>{p.supplierPhone || '—'}</td>
            </tr>
            <tr>
              <th>تاريخ التسديد</th>
              <td>{formatDateTime(p.paidAt)}</td>
              <th>طريقة الدفع</th>
              <td>{METHOD_LABELS[p.paymentMethod] || p.paymentMethod}</td>
            </tr>
            <tr>
              <th>القاصة</th>
              <td>{p.cashboxName || (p.paymentMethod === 'cash' ? '—' : 'لا تمسّ القاصة')}</td>
              <th>المستخدم المنفّذ</th>
              <td>{p.userName || '—'}</td>
            </tr>
            <tr>
              <th>المبلغ</th>
              <td colSpan={3} style={{ fontSize: '15px', fontWeight: 800 }}>{formatIQD(p.amount)}</td>
            </tr>
            {p.notes ? (
              <tr>
                <th>ملاحظات</th>
                <td colSpan={3}>{p.notes}</td>
              </tr>
            ) : null}
          </tbody>
        </table>

        {allocations.length ? (
          <div className="print-section mt-3">
            <h4 className="text-[13.5px] font-bold mb-1">الفواتير المسدَّدة بهذا السند</h4>
            <table>
              <thead>
                <tr>
                  <th>رقم الفاتورة</th>
                  <th>إجمالي الفاتورة</th>
                  <th>المسدَّد بهذا السند</th>
                  <th>المدفوع بعدها</th>
                  <th>المتبقي بعدها</th>
                </tr>
              </thead>
              <tbody>
                {allocations.map((a) => (
                  <tr key={String(a.invoiceId)}>
                    <td style={{ fontFamily: 'monospace' }}>{a.invoiceNumber}</td>
                    <td>{formatIQD(a.invoiceTotal)}</td>
                    <td style={{ fontWeight: 700 }}>{formatIQD(a.amount)}</td>
                    <td>{formatIQD(a.paidAfter)}</td>
                    <td>{formatIQD(a.remainingAfter)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}

        <div className="print-section mt-3">
          <table>
            <tbody>
              <tr>
                <th style={{ width: '50%' }}>رصيد المورد قبل السند</th>
                <td>{formatIQD(p.balanceBefore)}</td>
              </tr>
              <tr>
                <th>رصيد المورد بعد السند</th>
                <td style={{ fontWeight: 800 }}>{formatIQD(p.balanceAfter)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="print-section mt-6 flex justify-between text-[12.5px]">
          <div>توقيع المستلم: ..............................</div>
          <div>توقيع المحاسب: ..............................</div>
        </div>
      </div>
    </Modal>
  );
}
